import React from 'react';
import styled from 'styled-components';
import Visitor from '../../components/layouts/Visitor';
import HeaderOne from '../../components/parts/HeaderOne';
import AdministratorLoginForm from "../../components/combinations/AdministratorLoginForm";

const LoginStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const Login: React.FC = (() => {
  return (
    <Visitor>
      <LoginStyle>
        <HeaderOneStyle>管理者ログイン</HeaderOneStyle>
        <AdministratorLoginForm />
      </LoginStyle>
    </Visitor>
  );
});
export default Login;
